/*
 * Atelier — mobile drawer anchor
 * ------------------------------------------------------------------
 * The mobile menu drawer is position:absolute; top:100% on .header-section,
 * so it pins to the header's bottom. But per-page chrome sits BELOW the
 * header before <main>: the header-group's trailing divider (all pages) and
 * the quick-nav breadcrumb (product/collection/page/search/404, mobile too).
 * We want the drawer to align to the DIVIDER line (right under the header) on
 * every page and OVERLAY the breadcrumb bar — same look as the homepage — yet
 * still sit at the header bottom once scrolled/sticky (the chrome scrolls away).
 *
 * So set --drawer-chrome-offset = gap between .header-section's bottom and the
 * divider line, clamped >= 0. Reference for the divider line = the breadcrumb's
 * top when present (it sits right under the divider), else <main>'s top (home,
 * also right under the divider). Either way the offset == the divider height.
 * The drawer + backdrop shift down by it (CSS margin-top); 0 once scrolled.
 *
 * Recomputed on load, resize, and each menu open/close (scroll is locked while
 * the drawer is open, so the toggle moment is when it matters). No rAF — iOS
 * pauses it during scroll; these are discrete events.
 */
(function () {
  function update() {
    var header = document.querySelector('.header-section');
    var main = document.getElementById('MainContent');
    if (!header || !main) return;
    // Align to the divider line (right under the header), NOT below the
    // breadcrumb — the drawer should OVERLAY the breadcrumb, same as home.
    // Reference = breadcrumb top when present (== divider bottom), else <main>
    // top (home == divider bottom too). Gives the divider height on every page.
    var bc = document.querySelector('.atl-breadcrumb');
    var refTop = (bc || main).getBoundingClientRect().top;
    var gap = refTop - header.getBoundingClientRect().bottom;
    var offset = Math.max(0, Math.round(gap));
    document.body.style.setProperty('--drawer-chrome-offset', offset + 'px');
  }

  function init() {
    update();
    window.addEventListener('resize', update, { passive: true });
    document.querySelectorAll('.menu-drawer-container').forEach(function (d) {
      d.addEventListener('toggle', update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
